// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3Bt3L","range":"MonthRangeSwitch_range__15nXM","disabled":"MonthRangeSwitch_disabled__PuE8x"};